import axios from "../../../axios"
import {formatGraphqlBody, getCurrentTenant} from '@/utils'

export default {
  fetch: (search_filter = "", column = 'id', orderBy = 'ASC') => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          internalChatMessage(
            search_filter: "${search_filter}",
            orderBy: ["${column}", "${orderBy}"]                   
          )
          {
            id,
            ack,
            type,
            user_id,
            message,
            caption,
            tag_type,
            parent_id,
            created_at,
            unseen_msg,
            document_name,
            user_sending_id,
            document_mimetype
          }
        }
      `
    });
  },
  fetchPaginated: (
    userId,
    userSendingId,
    searchFilter = "",
    paginationPage = 1,
    paginationLimit = 10,
    sortName = "id",
    sortType = "DESC",
  ) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', formatGraphqlBody(
      'query',
      'paginatedInternalChatMessage',
      {
        0: 'total_pages',
        1: 'total_items',
        items: {
          0: 'id',
          1: 'ack',
          2: 'type',
          3: 'user_id',
          4: 'message',
          5: 'caption',
          6: 'tag_type',
          7: 'parent_id',
          8: 'unseen_msg',
          9: 'created_at',
          10: 'document_name',
          11: 'user_sending_id',
          12: 'document_mimetype',
          parentInternalChatMessage: {
            0: 'id',
            1: 'ack',
            2: 'type',
            3: 'user_id',
            4: 'message',
            5: 'caption',
            6: 'tag_type',
            7: 'parent_id',
            8: 'unseen_msg',
            9: 'created_at',
            10: 'document_name',
            11: 'user_sending_id',
            12: 'document_mimetype',
          }
        }
      },
      {
        from_chat: true,
        user_id: userId,
        user_sending_id: userSendingId,
        search_filter: searchFilter,
        orderBy: [sortName, sortType],
        pagination_page: paginationPage,
        pagination_limit: paginationLimit
      }
    ));
  },
  infos(internalChatMessageId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          internalChatMessageInfos(
            id: ${internalChatMessageId}
          )
          {
            id,
            ack,
            type,
            user_id,
            message,
            caption,
            tag_type,
            parent_id,
            created_at,
            unseen_msg,
            document_name,
            user_sending_id,
            document_mimetype
          }                    
        }
      `
    })
  },
  sendChatMessage: (data) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          sendMessageInternalChat (
            user_id: ${data.user_id},
            message: "${data.message}",
            user_sending_id: ${data.user_sending_id},
            ` + (!data.caption ? '' : `caption: "${data.caption}"`) + `,
            ` + (!data.tag_type ? '' : `tag_type: "${data.tag_type}"`) + `
            ` + (!data.parent_id ? '' : `parent_id: ${data.parent_id}`) + `,
            ` + (!data.from_chat ? '' : `from_chat: ${data.from_chat}`) + `,
          )
        }
      `
    })
  },
  sendChatImage: (data) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          sendImageInternalChat (
            user_id: ${data.user_id},
            image_url: "${data.image_url}",
            user_sending_id: ${data.user_sending_id},
            ` + (!data.caption ? '' : `caption: "${data.caption}"`) + `,
            ` + (!data.caption ? '' : `caption: "${data.caption}"`) + `,
            ` + (!data.tag_type ? '' : `tag_type: "${data.tag_type}"`) + `
            ` + (!data.parent_id ? '' : `parent_id: ${data.parent_id}`) + `,
            ` + (!data.from_chat ? '' : `from_chat: ${data.from_chat}`) + `,
            ` + (!data.image_caption ? '' : `image_caption: "${data.image_caption}"`) + `,
            ` + (!data.document_name ? '' : `document_name: "${data.document_name}"`) + `,
            ` + (!data.document_mimetype ? '' : `document_mimetype: "${data.document_mimetype}"`) + `,
          )
        }
      `
    })
  },
  resetUnseenInternalChatMessages(userId, userSendingId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          resetUnseenInternalChatMessages (
            user_id: ${userId} 
            user_sending_id: ${userSendingId} 
          )
        }
      `
    })
  },
  update: (id, data) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInternalChatMessage
          (
            id: ${data.id},
            type: ${data.type},
            user_id: ${data.user_id},
            message: "${data.message}",
            caption: "${data.caption}",
            tag_type: "${data.tag_type}",
            parent_id: ${data.parent_id},
            unseen_msg: "${data.unseen_msg}",
            document_name: "${data.document_name}",
            user_sending_id: ${data.user_sending_id},
            document_mimetype: "${data.document_mimetype}"
          ){
            id,
            ack,
            type,
            user_id,
            message,
            caption,
            tag_type,
            parent_id,
            created_at,
            unseen_msg,
            document_name,
            user_sending_id,
            document_mimetype
          }
        }
      `
    })
  },
  delete: ({id}) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteInternalChatMessage(
            id: ${id},
          )
        }
      `
    })
  }
}